module.exports = __webpack_public_path__ + "media/images/icon_search-301383a963403974c170299d9289e4ef.svg";